import React, { ReactElement } from 'react';
import { Input, InputProps } from 'antd';
import { Label } from '../Label';
import { omit } from 'lodash';
import { InputError } from '../InputError';
import { cn } from '@/utils/common';

interface TextInputProps extends InputProps {
  label?: string;
  error?: string;
  prefix?: ReactElement;
  labelStyles?: React.CSSProperties;
}

export const TextInput: React.FC<TextInputProps> = ({
  className,
  label,
  error,
  required,
  size = 'large',
  prefix,
  labelStyles,
  ...props
}) => {
  return (
    <div className="flex flex-col space-y-1">
      <Label label={label} required={required} styles={labelStyles} />
      {props.type === 'password' ? (
        <Input.Password
          {...omit(props, ['labelStyles', 'required', 'label'])}
          size={size}
          prefix={prefix}
          status={error ? 'error' : undefined}
          className={cn(className)}
        />
      ) : (
        <Input
          {...omit(props, ['labelStyles', 'required', 'label'])}
          size={size}
          prefix={prefix}
          status={error ? 'error' : undefined}
          className={cn(className)}
        />
      )}
      <InputError error={error} />
    </div>
  );
};
